import React from "react";
import Modal from "../../../../../components/Common/Modal/Modal";
import classes from "./ShotClassPreviewData.module.scss";
import { FormattedMessage } from "react-intl";
import Loader from "../../../../../components/Common/Loader/Loader";

const ShotClassPreviewData = ({
  previewSelectedDataModalOpen,
  setPreviewSelectedDataModalOpen,
  shotclassDataByProgram,
  previewCreator,
  previewCreatedOn,
  totalVideoDuration,
  loader,
}) => {
  return (
    <Modal
      isOpen={previewSelectedDataModalOpen}
      heading={<FormattedMessage id="PREVIEW_CARD_HEADER" />}
      toggle={() => setPreviewSelectedDataModalOpen(false)}
      width={"80"}
    >
      {loader ? (
        <div className={classes.loader}>
          <Loader />
        </div>
      ) : (
        <div className={classes.previewModalMain}>
          <div className={classes.previewModalLeftData}>
            <table>
              <tr>
                <th>
                  <FormattedMessage id="NAME_TEXT" />
                </th>
                <th>
                  <FormattedMessage id="PROGRAM_PREVIEW_SOURCE" />
                </th>
                {/* {shotclassDataByProgram?.map((data) => {
                return (
                  <>
                    {(data?.ShotClass?.Mediatype === 1 ||
                      data?.ShotClass?.Mediatype === 2) && (
                      <th>
                        <FormattedMessage id="PROGRAM_PREVIEW_DURATION" />
                      </th>
                    )}
                  </>
                );
              })} */}
                {totalVideoDuration[0] +
                  totalVideoDuration[1] +
                  totalVideoDuration[2] !==
                  0 && (
                  <th>
                    <FormattedMessage id="PROGRAM_PREVIEW_DURATION" />
                  </th>
                )}
              </tr>
              {shotclassDataByProgram?.map((data) => {
                return (
                  <tr key={data?.ShotClass?.ID}>
                    <td>{data?.ShotClass?.Name}</td>
                    <td>
                      {data?.ShotClass?.Mediatype === 1 ? (
                        "Video"
                      ) : data?.ShotClass?.Mediatype === 2 ? (
                        <FormattedMessage id="YOUTUBE_TEXT" />
                      ) : data?.ShotClass?.Mediatype === 3 ? (
                        "PPT"
                      ) : data?.ShotClass?.Mediatype === 4 ? (
                        "o365"
                      ) : data?.ShotClass?.Mediatype === 5 ? (
                        <FormattedMessage id="SLIDESHARE_TEXT" />
                      ) : data?.ShotClass?.Mediatype === 6 ? (
                        "oneDriveType"
                      ) : data?.ShotClass?.Mediatype === 7 ? (
                        "PDF"
                      ) : data?.ShotClass?.Mediatype === 8 ? (
                        "MOOC"
                      ) : data?.ShotClass?.Mediatype === 9 ? (
                        "Scorm"
                      ) : data?.ShotClass?.Mediatype === 10 ? (
                        "Image"
                      ) : data?.ShotClass?.Mediatype === 11 ? (
                        "HTML5"
                      ) : data?.ShotClass?.shotClassType === 5 ||
                        data?.ShotClass?.shotClassType === 6 ? (
                        <FormattedMessage id="QUIZ_TEXT" />
                      ) : data?.ShotClass?.shotClassType === 7 ? (
                        <FormattedMessage id="SURVEY_TEXT" />
                      ) : (
                        <></>
                      )}
                    </td>
                    {totalVideoDuration[0] +
                      totalVideoDuration[1] +
                      totalVideoDuration[2] !==
                      0 && (
                      <td>
                        {(data?.ShotClass?.Mediatype === 1 ||
                          data?.ShotClass?.Mediatype === 2) && (
                          <span>{data?.ShotClass?.VideoDuration}</span>
                        )}
                      </td>
                    )}
                  </tr>
                );
              })}
            </table>
          </div>
          <div className={classes.previewModalRightData}>
            <div className={classes.createdByNameAndOn}>
              <div className={classes.createdBy}>
                <FormattedMessage id="CREATED_BY" />{" "}
                <div className={classes.value}>{previewCreator}</div>
              </div>
              <div className={classes.createdOn}>
                <FormattedMessage id="CREATED_ON_TXT" />{" "}
                <div className={classes.value}>{previewCreatedOn}</div>
              </div>
            </div>
            {totalVideoDuration[0] +
              totalVideoDuration[1] +
              totalVideoDuration[2] !==
              0 && (
              <div className={classes.totalDuration}>
                <FormattedMessage id="TOTAL_DURATION" />
                {/* {shotclassDataByProgram?.map((data) => {
              return (
                <div
                  key={data?.ShotClass?.ID}
                  className={classes.totalDurationValue}
                >
                  {(data?.ShotClass?.Mediatype === 1 ||
                    data?.ShotClass?.Mediatype === 2) && (
                    <span className={classes.value}>
                      {data?.ShotClass?.VideoDuration}
                      {totalVideoDuration}
                    </span>
                  )}
                </div>
              );
            })} */}
                <div className={classes.totalDurationValue}>
                  <span className={classes.value}>
                    {totalVideoDuration[0] +
                      " Hrs " +
                      totalVideoDuration[1] +
                      " Min " +
                      totalVideoDuration[2] +
                      " Sec "}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ShotClassPreviewData;
